module.exports = __webpack_public_path__ + "static/media/blue.79aab4d6.png";